<template>
    <div>
        <signPC v-if="isPC" />
        <signH5 v-else />
    </div>
</template>
<script>
import signPC from '../components/pc';
import signH5 from '../components/signH5';
import loadScript from '../../../uitl/load-script';
export default {
  components: {
    signPC,
    signH5
  },
  mounted() {
    loadScript('https://hm.baidu.com/hm.js?001e5e9e10d733aa5b4d4d8dfcd24687');
    var _53code = document.createElement("script");
    _53code.src = "https://tb.53kf.com/code/code/90d3e270b5d355aa44bafe74fd7fe8a11/2";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(_53code, s);
  }
};
</script>
<style lang="less" scoped>

</style>